import React, {lazy, Suspense} from 'react';

const LazyFeaturesViewComponent = lazy(() => import('./FeaturesView'));

const FeaturesViewComponent = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyFeaturesViewComponent {...props} />
  </Suspense>
);

export default FeaturesViewComponent;
